import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "192",
    height: "192",
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["fill"];
const _hoisted_3 = ["fill"];
const _hoisted_4 = ["stroke"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("line", {
    x1: "69",
    y1: "110",
    x2: "161",
    y2: "110",
    stroke: "white",
    "stroke-width": "6",
    "stroke-linecap": "round"
}, null, -1 /* HOISTED */);
import { appState } from '@/composable/appState';
import { ChatBubbleType } from '@/helper/const';
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Bubble2Inactive',
    setup(__props) {
        const stroke = ref('#D0D5DD');
        const circleFill = ref('#1D2939');
        const rectFill = ref('#98A2B3');
        const setInitialColors = () => {
            const defaultValue = appState.chatWidgetSettingsData.promptType;
            if (defaultValue === ChatBubbleType.NORMAL) {
                stroke.value = '#B2CCFF';
                circleFill.value = '#0040C1';
                rectFill.value = '#528BFF';
            }
            else {
                stroke.value = '#D0D5DD';
                circleFill.value = '#1D2939';
                rectFill.value = '#98A2B3';
            }
        };
        watch(() => appState.chatWidgetSettingsData.promptType, newValue => {
            if (newValue === ChatBubbleType.NORMAL) {
                stroke.value = '#B2CCFF';
                circleFill.value = '#0040C1';
                rectFill.value = '#528BFF';
            }
            else {
                stroke.value = '#D0D5DD';
                circleFill.value = '#1D2939';
                rectFill.value = '#98A2B3';
            }
        });
        setInitialColors();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("circle", {
                    cx: "157",
                    cy: "157",
                    r: "15",
                    fill: circleFill.value
                }, null, 8 /* PROPS */, _hoisted_2),
                _createElementVNode("rect", {
                    x: "58",
                    y: "96",
                    width: "114",
                    height: "38",
                    rx: "4",
                    fill: rectFill.value
                }, null, 8 /* PROPS */, _hoisted_3),
                _createElementVNode("line", {
                    x1: "67.5",
                    y1: "120.5",
                    x2: "110.5",
                    y2: "120.5",
                    stroke: stroke.value,
                    "stroke-width": "3",
                    "stroke-linecap": "round"
                }, null, 8 /* PROPS */, _hoisted_4),
                _hoisted_5
            ]));
        };
    }
});
